var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h5',{staticClass:"user-list-header"},[_c('img',{staticClass:"user-list-header__icon",attrs:{"src":require("@/assets/staff.png"),"alt":""}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }